var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"store-event-shortcode"},[_c('div',{staticClass:"turnstile-container"},[(_vm.hasLogo)?_c('div',{staticClass:"logo-container"},[_c('img',{attrs:{"src":_vm.getAssets.images.finish.logo,"alt":"logo"}})]):_vm._e(),_c('div',{ref:"turnstileWidget",attrs:{"id":"cf-turnstile"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }